import React, {useEffect, useState} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import { errorMesg } from "./../../../Pages/Toaster";

import {getDispositionAPI, getSubDispositionAPI, editLeadAPI, updateLeadDataAPI, getStagesAPI} from "./../../../API/Team/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";


const EditLead = () =>{

    const {leadid} = useParams();
    const [txtname, setTxtName] = useState("");
    const [txtemail, setTxtEmail] = useState("");
    const [txtcontact, setTxtContact] = useState("");
    const [txtothercontact, setTxtOtherContact] = useState("");
    const [txtlocation, setTxtLocation] = useState("");
    const [txtdisposition, setTxtDisposition] = useState("");
    const [txtsubdisposition, setTxtSubDisposition] = useState("");
    const [scheduledate, setScheduleDate] = useState("");
    const [scheduletime, setScheduleTime] = useState("");
    const [txtremarks, setTxtRemarks] = useState("");
    const [txtotheremail, setTxtOtherEmail] = useState("");
    const [txtstage, setTxtStage] = useState("");
    const [stages, setStages] = useState([]);
    const [dispositions, setDispositions] = useState([]);
    const [subdispositions, setSubDispositions] = useState([]);
    const [remarks, setRemarks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnloading, setBtnLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() =>{

        //getDispositionAPI(setDispositions, setLoading);
        getStagesAPI(setStages, setLoading);

        editLeadAPI(leadid, setTxtName, setTxtEmail, setTxtContact, setTxtOtherContact, setTxtLocation, setTxtDisposition, setTxtSubDisposition, setScheduleDate, setScheduleTime, setTxtRemarks, setLoading, setRemarks, setTxtOtherEmail);

    }, []);

    const handleUpdateLead = () =>{

        if(txtremarks.length < 15)
        {
            errorMesg("Remarks length should be minimum 15 character");
            return;
        }

        const params = {
                        "leadid": leadid,
                        "other_contact": txtothercontact,
                        "stage": txtstage,
                        "disposition": txtdisposition,
                        "subdisposition": txtsubdisposition,
                        "txtremark": txtremarks,
                        "notify_date": scheduledate,
                        "notify_time": scheduletime,
                        "other_email": txtotheremail,
                    };

        
        updateLeadDataAPI(params, setBtnLoading, navigate);
    }

    const handleInputName = (event) =>{
        setTxtName(event.target.value);
    }

    const handleInputEmail = (event) =>{
        setTxtEmail(event.target.value);
    }

    const handleInputContact = (event) =>{
        setTxtContact(event.target.value);
    }

    const handleInputOtherContact = (event) =>{
        setTxtOtherContact(event.target.value);
    }

    const handleInputLocation = (event) =>{
        setTxtLocation(event.target.value);
    }

    const handleSelectStage = (event) =>{
        setTxtStage(event.target.value);

        getDispositionAPI(event.target.value, setDispositions);
    }

    const handleSelectDisposition = (event) =>{
        setTxtDisposition(event.target.value);

        getSubDispositionAPI(event.target.value, setSubDispositions);
    }

    const handleSelectSubDisposition = (event) =>{
        setTxtSubDisposition(event.target.value);
    }

    const handleScheduleDate = (event) =>{
        setScheduleDate(event.target.value);
    }

    const handleScheduleTime = (event) =>{
        setScheduleTime(event.target.value);
    }

    const handleRemarks = (event) =>{
        setTxtRemarks(event.target.value);
    }

    const handleInputOtherEmail = (event) =>{
        setTxtOtherEmail(event.target.value);
    }



    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper cardhead">
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row">
                        <div className="col">
                            <h3 className="page-title">Edit Lead</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <form method="post" name="frmeditlead" id="frmeditlead">
                                    { loading ?
                                        <Loader />

                                    :
                                        <>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label"> Name</label>
                                                        <input type="text" className="form-control" name="leadname" id="leadname" value={txtname} onChange={handleInputName} />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label"> Email</label>
                                                        <input type="text" className="form-control" name="leademail" id="leademail" value={txtemail} onChange={handleInputEmail} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label"> Alternate Email</label>
                                                        <input type="email" className="form-control" name="otheremail" id="otheremail" value={txtotheremail} onChange={handleInputOtherEmail} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label"> Contact</label>
                                                        <input type="text" className="form-control" name="leadcontact" id="leadcontact" value={txtcontact} onChange={handleInputContact} />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label"> Alternate Contact</label>
                                                        <input type="text" className="form-control" name="othercontact" id="othercontact" value={txtothercontact} onChange={handleInputOtherContact} />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label"> Location</label>
                                                        <input type="text" className="form-control" name="location" id="location" value={txtlocation} onChange={handleInputLocation} />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Lead Stage</label>
                                                        <select className="form-control" name="stages" id="stages" value={txtstage} onChange={handleSelectStage}>
                                                            <option value="">Select</option>
                                                            {stages && stages.length > 0 ?
                                                                (stages.map(stage =>
                                                                    (
                                                                        <option value={stage.id} key={stage.id}>{stage.name}</option>
                                                                    )
                                                                )

                                                                )
                                                            :
                                                                <></>
                                                            }

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Disposition</label>
                                                        <select className="form-control" name="disposition" id="disposition" value={txtdisposition} onChange={handleSelectDisposition}>
                                                            <option value="">Select</option>
                                                            {dispositions && dispositions.length > 0 ?
                                                                (dispositions.map(disposition =>
                                                                    (
                                                                        <option value={disposition.id} key={disposition.id}>{disposition.name}</option>
                                                                    )
                                                                )

                                                                )
                                                            :
                                                                <></>
                                                            }

                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Reason</label>
                                                        <select className="form-control" name="subdisposition" id="subdisposition" value={txtsubdisposition} onChange={handleSelectSubDisposition}>
                                                            <option value="">Select</option>
                                                            {subdispositions && subdispositions.length > 0 ?
                                                                (subdispositions.map(subdisp =>
                                                                    (
                                                                        <option value={subdisp.id} key={subdisp.id}>{subdisp.name}</option>
                                                                    )
                                                                )

                                                                )
                                                            :
                                                                <></>
                                                            }

                                                        </select>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-7">
                                                            <div className="mb-3">
                                                                <label className="form-label">Schedule Date</label>
                                                                <input type="date" className="form-control" name="scheduledate" id="scheduledate" value={scheduledate} onChange={handleScheduleDate} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label">Schedule Time</label>
                                                                <input type="time" className="form-control" name="scheduletime" id="scheduletime" value={scheduletime} onChange={handleScheduleTime} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Remarks</label>
                                                <textarea className="form-control" name="remarks" id="remarks" cols="50" rows="5" onChange={handleRemarks}>{txtremarks}</textarea>

                                            </div>

                                            <div className="text-end">
                                                <button type="button" className="btn btn-primary"  onClick={handleUpdateLead}>
                                                    {btnloading ?
                                                        <div className="spinner-border" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    :
                                                        <p>Update Lead</p>
                                                    }
                                                </button>
                                            </div>
                                        </>
                                    }
                                </form>

                            </div>
                        </div>

                    </div>

                    {remarks && remarks.length > 0 ?
                    <div class="col-lg-4">
                        <div class="card remarks-timeline mb-30">
                            <div class="title d-flex flex-wrap align-items-center justify-content-between mb-3">
                                <div class="left">
                                    <h6 class="text-medium mb-30">Latest Remarks</h6>
                                </div>
                                <div class="right">
                                    {/*<p class="mb-30">
                                        <Link to={`/team/lead/remarks/${leadid}`} target="_blank">view all</Link>
                                    </p>*/}
                                </div>
                            </div>
                            <ul class="timeline-3">
                                {remarks.map(remark =>
                                    <li key={remark.id}>
                                        <span className="remark-heading">{remark.userdata.name}</span>
                                        {/*<span className="remark-date float-end">{moment(remark.created_at).format('DD MMM, YYYY')}</span>*/}
                                        <p class="mt-2">{remark.remarks}</p>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    :
                        <></>
                    }

                </div>

            </div>
        </div>

        <ToastContainer />

    </div>
    )
}

export default EditLead;
